import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const UserTypes = () => {
  const [userTypes, setUserTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);
  const PROFILE_PHOTO_BASE_URL = 'https://www.startupbusinesspartners.com/uploads/profile-photos/';

  useEffect(() => {
    const fetchUserTypes = async () => {
      try {
        setLoading(true);
        const response = await api.get('/user-types');

        if (!response.data.success) {
          throw new Error(response.data.message || 'Failed to fetch user types');
        }

        setUserTypes(response.data.data || []);
      } catch (err) {
        console.error('Error fetching user types:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserTypes();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
    customPaging: i => (
      <button className="w-8 h-8 rounded-full bg-gray-300 transition-colors duration-300 hover:bg-gray-600 aria-selected:bg-blue-600 aria-selected:w-10 aria-selected:h-10" />
    ),
  };

  if (loading) {
    return <div className="text-center py-8">Loading user types...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">Error: {error}</div>;
  }

  return (
    <section className="case_studies py-[50px] bg-gray-100 mb-4">
      <div className="container mx-auto">
        <div className="row flex justify-center">
          <div className="col w-full text-center">
            <h1 className="text-4xl font-semibold leading-tight">
              We are building great future <br />together, Be with us
            </h1>
          </div>
        </div>

        <div className="mt-8">
          {userTypes.length > 0 ? (
            <Slider {...settings} className="carousel-two relative">
              {userTypes.map((type) => (
             <div key={type.user_type} className="px-4">
  <Link
    to={`/users?type=${encodeURIComponent(type.user_type)}`}
    className="block"
  >
    <div
      onMouseEnter={() => setHoveredCard(type.user_type)}
      onMouseLeave={() => setHoveredCard(null)}
      style={{
        backgroundColor: hoveredCard === type.user_type ? "#f9fafb" : "#ffffff",
        borderRadius: "12px",
        boxShadow:
          hoveredCard === type.user_type
            ? "0 10px 28px rgba(0,0,0,0.18)"
            : "0 4px 12px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease-in-out",
        padding: "10px",
        marginBottom: "20px",
        cursor: "pointer",
        transform:
          hoveredCard === type.user_type ? "translateY(-6px)" : "translateY(0)",
      }}
    >
      <figure className="overflow-hidden">
        <img
          src={
            type.sample_image
              ? `${PROFILE_PHOTO_BASE_URL}${type.sample_image}`
              : "https://img.freepik.com/free-photo/blue-user-icon-symbol-website-admin-social-login-element-concept-white-background-3d-rendering_56104-1217.jpg"
          }
          alt={type.user_type}
          className="w-full"
          style={{ objectFit: "cover" }}
        />
      </figure>

      <div className="p-4 text-center">
        <h6
          className="text-lg font-bold transition-colors duration-300"
          style={{
            color:
              hoveredCard === type.user_type ? "#2563eb" : "#1f2937",
            textDecoration:
              hoveredCard === type.user_type ? "underline" : "none",
          }}
        >
          {type.user_type === "Business"
            ? "Business for Sell"
            : type.user_type === "Employee"
            ? "Skilled Business Employee"
            : type.user_type}{" "}
          ({type.count || 0})
        </h6>
      </div>
    </div>
  </Link>
</div>

              ))}
            </Slider>
          ) : (
            <div className="text-center py-8">No user types available</div>
          )}
        </div>
      </div>
    </section>
  );
};

export default UserTypes;